<template>
  <div class="ui pagination menu" :class="menuSizeClass">
    <div class="item"
         @click="currentPageNumber = 1"
         :class="{ disabled: currentPageNumber <= 1 }">
      {{ firstPageButtonText }}
    </div>
    <div class="item"
         @click="changeCurrentPage(-1)"
         :class="{ disabled: currentPageNumber <= 1 }">
      {{ prevButtonText }}
    </div>

    <div class="item"
         v-for="i in numberToArray(getStartPagesMargin()).reverse()"
         @click="changeCurrentPage(-1 * i)"
         v-if="currentPageNumber !== 1 && numberOfPages">
      {{ currentPageNumber - i }}
    </div>
    <div class="active item">
      {{ currentPageNumber  }}
    </div>
    <div class="item"
         v-if="currentPageNumber !== lastPageNumber && getLastPagesMargin() && lastPageNumber > 1"
         v-for="i in getLastPagesMargin()"
         @click="changeCurrentPage(i)">
      {{ currentPageNumber + i }}
    </div>

    <div class="item"
         @click="changeCurrentPage(1)"
         :class="{ disabled: currentPageNumber >= lastPageNumber }">
      {{ nextButtonText }}
    </div>
    <div class="item"
         @click="currentPageNumber = lastPageNumber"
         :class="{ disabled: currentPageNumber >= lastPageNumber }">
      {{ lastPageButtonText }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    firstPageButtonText: { type: String, default: 'first' },
    lastPageButtonText: { type: String, default: 'last' },
    prevButtonText: { type: String, default: 'pervious' },
    nextButtonText: { type: String, default: 'next' },
    menuSizeClass: { type: String, default: 'tiny' },
    paginatorId: { type: String, default: '' },
    numberOfPages: { type: Number, required: true },
    marginPages: { type: Number, default: 2 },
    selectedPage: { type: Number, default: 1 }
  },
  data () {
    return {
      currentPageNumber: 1
    }
  },
  computed: {
    lastPageNumber () {
      return this.numberOfPages
    },
    firstPageNumber () {
      return 1
    }
  },
  watch: {
    currentPageNumber: {
      handler: function () {
        this.$emit(`pagination${this.paginatorId}`, { pageNumber: this.currentPageNumber })
      }
    },
    selectedPage: {
      handler: function () {
        this.currentPageNumber = this.selectedPage
      },
      deep: true
    }
  },
  methods: {
    numberToArray (number) {
      let arr = []
      for (let i = 1; i <= number; ++i) {
        arr.push(i)
      }
      return arr
    },
    getStartPagesMargin () {
      if (this.currentPageNumber - this.firstPageNumber < this.marginPages) {
        return this.currentPageNumber - 1
      }

      return this.marginPages
    },
    getLastPagesMargin () {
      if (this.lastPageNumber <= 1) {
        return 0
      }

      if (this.lastPageNumber - this.currentPageNumber < this.marginPages) {
        return this.lastPageNumber - this.currentPageNumber
      }

      return this.marginPages
    },
    changeCurrentPage (margin = 0) {
      if (this.currentPageNumber + margin < 1 || this.currentPageNumber + margin > this.lastPageNumber) {
        return
      }

      this.currentPageNumber += margin
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/abstract_components/PaginationComponent.vue